document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelector('.resources-tabs');
  const btnResourceTemplates = document.getElementById(
    'btn-resource-templates'
  );
  if (tabs && btnResourceTemplates) {
    const btnResourceTemplates = document.getElementById(
      'btn-resource-templates'
    );
    const btnBlog = document.getElementById('btn-blog');
    const btnEbooks = document.getElementById('btn-ebooks');
    const btnLeadership = document.getElementById('btn-leadership');

    const resourceTemplates = document.getElementById('resource-templates');
    const resourceBlog = document.getElementById('resource-blog');
    const resourceEbooks = document.getElementById('resource-ebooks');
    const resourceLeadership = document.getElementById('resource-leadership');

    btnResourceTemplates.addEventListener('click', () => {
      removeActive();
      btnResourceTemplates.classList.add('active');
      resourceTemplates.style.display = 'block';
    });

    btnBlog.addEventListener('click', () => {
      removeActive();
      btnBlog.classList.add('active');
      resourceBlog.style.display = 'block';
    });

    btnEbooks.addEventListener('click', () => {
      removeActive();
      btnEbooks.classList.add('active');
      resourceEbooks.style.display = 'block';
    });

    btnLeadership.addEventListener('click', () => {
      removeActive();
      btnLeadership.classList.add('active');
      resourceLeadership.style.display = 'block';
    });

    function removeActive() {
      btnResourceTemplates.classList.remove('active');
      btnBlog.classList.remove('active');
      btnEbooks.classList.remove('active');
      btnLeadership.classList.remove('active');

      resourceTemplates.style.display = 'none';
      resourceBlog.style.display = 'none';
      resourceEbooks.style.display = 'none';
      resourceLeadership.style.display = 'none';
    }
  }
});
